import { Download } from 'lucide-react';
import type { MainTableColumn } from '@/components/company/table/MainTable';
import type { IPunishment } from '@/states/punishment.state';

export const punishmentColumns: MainTableColumn[] = [
  {
    name: 'org_chart_node.name',
    label: 'Role',
    render: (_: unknown, row: IPunishment) => row?.org_chart_node?.name ?? '-',
  },
  { name: 'name', label: 'Name' },
  { name: 'value', label: 'Punishment' },
  {
    name: 'description',
    label: 'Description',
    render: (val: string) => (
      <div className="max-w-xs truncate" dangerouslySetInnerHTML={{ __html: val || '-' }} />
    ),
  },
  {
    name: 'fileUrl',
    label: 'File',
    render: (_: any, row: IPunishment) =>
      row.fileUrl ? (
        <a
          href={row.fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-800 cursor-pointer"
        >
          <Download className="w-4 h-4" />
          <span>Download</span>
        </a>
      ) : (
        '-'
      ),
  },
  {
    name: 'is_published',
    label: 'Publish',
    render: (val: boolean) =>
      val ? (
        <span className="text-green-700 bg-green-100 border inline-block border-green-300 px-2 rounded-lg">
          Published
        </span>
      ) : (
        <span className="text-red-700 bg-red-100 border inline-block border-red-300 px-2 rounded-lg">
          Unpublished
        </span>
      ),
  },
];
